import { combineReducers } from 'redux';
import { folioReducer } from './folioReducer';


const myCollectionsReducer = combineReducers({
  folios: folioReducer,
})

export { myCollectionsReducer };